export default "__VITE_ASSET__BnpA4UTY__"